/* Lack Depot — Free shipping progress bar updater
   Listens for cart changes (fetch /cart/add, /cart/change, /cart/update, /cart/clear)
   and refreshes the [data-ldfs] progress bar's percentage + message inline.
   Threshold and locale come from the data attributes on the snippet. */

(function () {
  'use strict';

  function moneyFormat(cents) {
    // Format as German euro (1.234,56 €) or English ($1,234.56 — never used here, EU shop)
    const isEn = (document.documentElement.lang || '').toLowerCase().startsWith('en');
    const euros = (cents / 100);
    if (isEn) {
      return '€' + euros.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }
    return euros.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
  }

  function renderMessage(remainingCents, isEn) {
    if (remainingCents <= 0) {
      if (isEn) return '<strong>Free shipping unlocked!</strong> Your order ships free within Germany.';
      return '<strong>Versandkostenfrei freigeschaltet!</strong> Ihre Bestellung wird kostenlos versendet.';
    }
    const formatted = moneyFormat(remainingCents);
    if (isEn) {
      return 'Add <strong data-ldfs-remaining>' + formatted + '</strong> more to qualify for <strong>free shipping</strong>.';
    }
    return 'Noch <strong data-ldfs-remaining>' + formatted + '</strong> bis zum <strong>kostenlosen Versand</strong>.';
  }

  function updateBar(bar, totalCents) {
    const threshold = parseInt(bar.dataset.ldfsThreshold, 10) || 10000;
    const isEn = (bar.dataset.ldfsLocale || 'de') === 'en';
    let remaining = threshold - totalCents;
    if (remaining < 0) remaining = 0;
    let pct = (totalCents / threshold) * 100;
    if (pct > 100) pct = 100;

    const fill = bar.querySelector('[data-ldfs-fill]');
    const msg = bar.querySelector('[data-ldfs-msg]');
    const track = bar.querySelector('[role="progressbar"]');

    if (fill) fill.style.width = pct + '%';
    if (msg) msg.innerHTML = renderMessage(remaining, isEn);
    if (track) track.setAttribute('aria-valuenow', Math.round(pct));

    bar.classList.toggle('is-complete', remaining <= 0);
  }

  function refresh() {
    const bars = document.querySelectorAll('[data-ldfs]');
    if (!bars.length) return;
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        bars.forEach(function (b) { updateBar(b, cart.items_subtotal_price != null ? cart.items_subtotal_price : cart.total_price); });
      })
      .catch(function () { /* silent */ });
  }

  // 1. Intercept fetch() so any /cart/add|change|update|clear triggers a refresh
  if (window.fetch) {
    const origFetch = window.fetch;
    window.fetch = function (input, init) {
      const url = (typeof input === 'string') ? input : (input && input.url) || '';
      const promise = origFetch.apply(this, arguments);
      if (/\/cart\/(add|change|update|clear)/i.test(url)) {
        promise.then(function () { setTimeout(refresh, 60); }).catch(function () {});
      }
      return promise;
    };
  }

  // 2. Also intercept XMLHttpRequest for older theme code
  if (window.XMLHttpRequest) {
    const origOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      this.addEventListener('load', function () {
        if (/\/cart\/(add|change|update|clear)/i.test(url || '')) {
          setTimeout(refresh, 60);
        }
      });
      return origOpen.apply(this, arguments);
    };
  }

  // 3. Listen to common theme events
  ['cart:updated', 'cart:refresh', 'cart:change', 'shopify:cart:update'].forEach(function (ev) {
    document.addEventListener(ev, refresh);
  });

  // 4. Observe the cart drawer for re-renders (Dawn-style themes)
  function watchDrawer() {
    const drawer = document.querySelector('cart-drawer, #CartDrawer, .cart-drawer');
    if (!drawer) return;
    const observer = new MutationObserver(function () { refresh(); });
    observer.observe(drawer, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchDrawer);
  } else {
    watchDrawer();
  }
})();
